export const LOGIN = "/login";
export const SETTINGS = "/settings";
export const ORDERS = "/";
export const ORDER = "/order";
export const CALENDAR = "/calendar";
export const ORDER_REQUEST = "/order-request";
